import type { ApiUser } from '#/api/userEnvironment/types/ApiUserEnvironment';
import {
  LayoutHeaderPanelLink,
  LayoutHeaderPanelSectionTitle,
} from '#/layouts/Layout/Header/Panel/LayoutHeaderPanel.styled';
import { LayoutHeaderPanelRowContent } from '#/layouts/Layout/Header/Panel/LayoutHeaderPanelRowContent';
import type { MyAccountRowType } from '#/layouts/Layout/Header/UserItems/dropdowns/my-account/useMyAccountRows';
import { useMyAccountRows } from '#/layouts/Layout/Header/UserItems/dropdowns/my-account/useMyAccountRows';

import {
  HamburgerMenuRowsHolder,
  HamburgerMenuSectionHolder,
} from './HamburgerMenu.styled';
import { hamburgerMenuTrackingName } from './hamburgerMenuConstants';

type Props = {
  user: ApiUser;
  title: string;
};

const order: MyAccountRowType[] = [
  'notification-preferences',
  'account-settings',
  'profile',
  'saved-items',
  'professional-experience',
  'application-history',
];

const trackingContext = `${hamburgerMenuTrackingName} > My Account`;

export function HamburgerMenuMyAccountSection({ user, title }: Props) {
  const rows = useMyAccountRows(user, order);

  return (
    <HamburgerMenuSectionHolder data-qa-id="hamburger-menu-section-my-account">
      <LayoutHeaderPanelSectionTitle>{title}</LayoutHeaderPanelSectionTitle>

      <HamburgerMenuRowsHolder>
        {rows.map((row) => (
          <li key={row.type}>
            <LayoutHeaderPanelLink
              type="link"
              href={row.href}
              qaId={`hamburger-menu-${row.type}-link`}
              clickActions={{
                closeRichDetailsFromWithin: true,
                track: {
                  name: 'Header Dropdown Link',
                  properties: {
                    link_type: row.linkType,
                    context: trackingContext,
                  },
                },
              }}
            >
              <LayoutHeaderPanelRowContent
                icon={{ kind: 'icon', name: row.icon }}
                title={row.label}
              />
            </LayoutHeaderPanelLink>
          </li>
        ))}
      </HamburgerMenuRowsHolder>
    </HamburgerMenuSectionHolder>
  );
}
